export const DID_RANGE_START = "047777600";
export const DID_RANGE_END = "047777699";
export const GOLDEN_REFERENCE_DID = "047777666";
export const DEFAULT_ELEVENLABS_AGENT_ID = "agent_1301kh111e5bejjt7ybx8nzqer45";
export const PUBLIC_VOICE_IP = "5.32.91.6";

export type DidStatus =
  | "available"
  | "reserved"
  | "assigned"
  | "configured"
  | "testing"
  | "live"
  | "retired"
  | "blocked";

export type ManualStatus = "not_started" | "manual_pending" | "configured" | "verified";

export type TestResult = "not_tested" | "greeting_only" | "two_way_audio_ok" | "failed";

export type DidProtection = "normal" | "golden_reference";

export type AssignedUser = {
  company_name?: string;
  name: string;
  email: string;
  crm_contact_id?: string;
  notes?: string;
};

export type AssistantProfile = {
  type: "meydan_operator" | "customer_pa" | "vendor_pa" | "custom";
  display_name?: string;
  owner?: string;
  notes?: string;
};

export type VendorProfile = {
  vendor_name?: string;
  contact_email?: string;
  pa_dashboard_customer_id?: string;
  elevenlabs_account_name?: string;
  elevenlabs_account_owner_email?: string;
  handoff_notes?: string;
  current_provider?: "twilio" | "elevenlabs_sip" | "other";
  target_provider?: "elevenlabs_sip";
};

export type DidInventoryItem = {
  did: string;
  e164: string;
  range_id: "meydan-0477776xx";
  extension_suffix: string;
  status: DidStatus;
  protection: DidProtection;
  assigned_user: AssignedUser | null;
  assigned_agent_id?: string;
  assistant_profile?: AssistantProfile;
  vendor_profile?: VendorProfile;
  elevenlabs_phone_number_id?: string;
  pbx_route_status: ManualStatus;
  pbx_dial_pattern_status: ManualStatus;
  elevenlabs_status: ManualStatus;
  last_test_result: TestResult;
  config_snapshot?: ConfigSnapshot;
  notes?: string;
  created_at: string;
  updated_at: string;
  updated_by: string;
};

export type AuditEvent = {
  audit_id: string;
  did: string;
  event_type:
    | "seed_range"
    | "did_created"
    | "did_updated"
    | "config_generated"
    | "verification_updated";
  actor: string;
  before?: Record<string, unknown>;
  after?: Record<string, unknown>;
  metadata?: Record<string, unknown>;
  created_at: string;
};

export type ConfigSnapshot = {
  generated_at: string;
  version: "did-config-v1";
  e164: string;
  pbx: {
    one_time_dial_patterns: Array<{
      route: "To_ElevenLabs";
      pattern: string;
      strip: number;
      prepend: string;
      scope: "one_time_range_prerequisite" | "optional_e164_input";
    }>;
    carrier_trunk: {
      name: "Peer_047777666";
      media_ip_mode: "default_local";
      notes: string;
    };
    elevenlabs_trunk: {
      transport: "tls";
      port: 5061;
      host: "sip.rtc.elevenlabs.io";
      media_ip_mode: "custom_public";
      media_ip: typeof PUBLIC_VOICE_IP;
      codec_order: ["ulaw", "alaw"];
      srtp: false;
      rtp_keepalive: true;
    };
  };
  elevenlabs: {
    phone_number: string;
    agent_id: string;
    assistant_profile_type: AssistantProfile["type"];
    vendor_handoff?: {
      purpose: string;
      vendor_name?: string;
      elevenlabs_account_name?: string;
      elevenlabs_account_owner_email?: string;
      handoff_notes?: string;
      current_provider?: string;
      target_provider: "elevenlabs_sip";
    };
    inbound_trunk_config: {
      allowed_addresses: [`${typeof PUBLIC_VOICE_IP}/32`];
      allowed_numbers: null;
      media_encryption: "disabled";
    };
    outbound_trunk_config: {
      address: typeof PUBLIC_VOICE_IP;
      transport: "tls";
      media_encryption: "disabled";
    };
  };
};
